import React from 'react';
import {Flex, Text} from '@priority-software/priority-style-react';
import styles from './styles.module.scss';
import {ColumnsData} from '../../types';
import {IMG_FIELD_NAME} from '../../consts';

interface Props {
    columnsData: ColumnsData[];
    partName: string;
}

const Details = ({columnsData, partName}: Props) => {
    const filteredList = columnsData?.filter(col => col.columnName !== IMG_FIELD_NAME);
    if (!filteredList?.length) {
        return null;
    }

    return (
        <Flex
            componentClasses={styles.detailsContainer}
            direction="row"
            justifyContent="flex-start"
            alignItems="center"
            skin="snow"
            wrap={false}
        >
            {filteredList?.map(partInvInfo => {
                return (
                    <Flex
                        componentClasses={styles.detailsItem}
                        key={partInvInfo.columnName + partName}
                        direction="column"
                        justifyContent="flex-start"
                        alignItems="stretch"
                    >
                        <Text
                            componentClasses={styles.ellipsis}
                            wrap={false}
                            textColor="secondary-400"
                        >
                            {partInvInfo.columnTitle}
                        </Text>
                        <Text
                            componentClasses={styles.ellipsis}
                            wrap={false}
                            textColor="primary-700"
                        >
                            {partInvInfo.value}
                        </Text>
                    </Flex>
                );
            })}
        </Flex>
    );
};

export default Details;
